<template>
  <div>
    <!-- Price Section start-->
    <section id="price" class="price">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <carousel :className='"price-carousel"'
                      :loop=true
                      :margin=30
                      :items=3
                      :center=false
                      :nav=false
                      :dots=false
                      :dotsEach=false
                      :autoplay=false
                      :responsive="{0:{items:1, dots:true},600:{items:1,dots:true},768:{items:2,dots:true},992:{items:3,nav:false},1000:{items:3,nav:false}}"
            >
              <div class="price-item">
                <div class="price-block">
                  <div class="price-type">
                    <h2>monthly</h2>
                  </div>
                  <div class="mrp">
                    <h6 class="user-type">Premium Access</h6>
                    <div class="price-devide"></div>
                    <h2>$3.99 USD</h2>
                    <h6 class="price-year">per month</h6>
                    <div class="price-devide"></div>
                  </div>
                  <ul class="price-feature">
                    <li>Access to loop library</li>
                    <li>real time setlist sharing</li>
                    <li>unlimited setlists</li>
                    <li>email support</li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div>
              </div>

              <div class="price-item">
                <div class="price-block">
                  <div class="price-type">
                    <h2>Yearly</h2>
                  </div>
                  <div class="mrp">
                    <h6 class="user-type">Premium Access</h6>
                    <div class="price-devide"></div>
                    <h2>$39.99 USD</h2>
                    <h6 class="price-year">per Year</h6>
                    <div class="price-devide"></div>
                  </div>
                  <ul class="price-feature">
                    <li>Access to loop library</li>
                    <li>real time setlist sharing</li>
                    <li>unlimited setlists</li>
                    <li>email support</li>
                    <li>15% Savings</li>
                    <li></li>
                  </ul>
                </div>
              </div>

              <div class="price-item">
                <div class="price-block">
                  <div class="price-type">
                    <h2>Group Plans</h2>
                  </div>
                  <div class="mrp">
                    <h6 class="user-type">Our biggest plan</h6>
                    <div class="price-devide"></div>
                    <h6 class="price-year">starting at</h6>
                    <h2>$119.99 USD</h2>
                    <h6 class="price-year">per year</h6>
                    <div class="price-devide"></div>
                  </div>
                  <ul class="price-feature">
                    <li>All features from yearly plan</li>
                    <li>Up to 10 users</li>
                    <li>priority email support</li>
                    <li>up to 50% Savings</li>
                    <li>Contact support for Enquiries</li>
                  </ul>
                </div>
                  </div>
            </carousel>
          </div>
        </div>
      </div>
    </section>
    <!-- Price Section End -->
  </div>
</template>
<script>

export default {
  name: 'Price'
}
</script>



// WEBPACK FOOTER //
// src/components/price.vue